import clsx from 'clsx';

export interface IconCrossProps {
  className?: string;
}

const IconCross = ({ className }: IconCrossProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      'transition-all duration-300 motion-reduce:transition-none',
      className,
    )}
  >
    <path d="M6.00015 7.229L1.97915 11.25C1.81248 11.4167 1.61115 11.4967 1.37515 11.49C1.13915 11.4827 0.937817 11.3957 0.77115 11.229C0.604483 11.0623 0.52115 10.8577 0.52115 10.615C0.52115 10.3717 0.604483 10.1667 0.77115 10L4.77115 6L0.75015 1.979C0.583483 1.81233 0.503484 1.60767 0.51015 1.365C0.517484 1.12167 0.604483 0.916667 0.77115 0.75C0.937817 0.583333 1.14248 0.5 1.38515 0.5C1.62848 0.5 1.83348 0.583333 2.00015 0.75L6.00015 4.771L10.0211 0.75C10.1878 0.583333 10.3925 0.5 10.6351 0.5C10.8785 0.5 11.0835 0.583333 11.2501 0.75C11.4168 0.916667 11.5001 1.12167 11.5001 1.365C11.5001 1.60767 11.4168 1.81233 11.2501 1.979L7.22915 6L11.2501 10.021C11.4168 10.1877 11.5001 10.389 11.5001 10.625C11.5001 10.861 11.4168 11.0623 11.2501 11.229C11.0835 11.3957 10.8785 11.479 10.6351 11.479C10.3925 11.479 10.1878 11.3957 10.0211 11.229L6.00015 7.229Z" />
  </svg>
);

export default IconCross;
